import React, { useCallback, useState } from 'react';
import { Typography } from 'fronton-react';
import { ChevronCircleRightIcon } from '@fronton/icons-react';
import { useTranslation } from 'react-i18next';
import { StoreStockData } from './types';
import {
  stockInStoresTitleText,
  stockInStoresTitleContainer,
  showMoreStocks,
  stockInStoresTitleDisplayText,
} from './styles';
import { StocksInStoresInteractiveModal } from './stocks-in-stores-interactive-modal';

type TitleInteractiveProps = {
  stocks: StoreStockData[];
  onStockListShowDispatch: () => void;
  otherContent: JSX.Element;
};

export const TitleInteractive: React.FC<TitleInteractiveProps> = ({
  stocks,
  onStockListShowDispatch,
  otherContent,
}) => {
  const { t } = useTranslation();
  const availableStocksCount = stocks.filter((stock) => stock.stockValue > 0).length;
  const availableDisplayCount = stocks.filter(
    (stock) => stock.stockValue === 0 && stock.displaySample === true,
  ).length;
  const showDisplay = availableStocksCount === 0 && availableDisplayCount > 0;

  const [modalVisibility, setModalVisibility] = useState(false);

  const onClick = useCallback(() => {
    setModalVisibility(true);
    onStockListShowDispatch();
  }, [onStockListShowDispatch]);

  return (
    <>
      <div onClick={onClick} style={{ cursor: 'pointer' }}>
        <div className={stockInStoresTitleContainer} data-qa="stock-in-stores-title-interactive">
          <Typography
            className={showDisplay ? stockInStoresTitleDisplayText : stockInStoresTitleText}
            color={showDisplay ? 'secondary-blue-primary' : 'success-dark'}
            size="body_accent"
            variant="s"
            data-qa="title-interactive-stocks-text"
          >
            {showDisplay
              ? t('product-info.stocks.in-stores.title-display', { count: Number(availableDisplayCount) })
              : t('product-info.stocks.in-stores.title', { count: Number(availableStocksCount) })}
          </Typography>
          <ChevronCircleRightIcon
            type="fill"
            color={showDisplay ? 'secondary-blue-primary' : 'success-dark'}
            size="l"
            data-qa="title-interactive-button"
            className={showMoreStocks}
          />
        </div>
        {otherContent}
      </div>
      <StocksInStoresInteractiveModal
        modalVisibility={modalVisibility}
        setModalVisibility={setModalVisibility}
        shopsList={stocks}
      />
    </>
  );
};
